const JsonDownloadHandler = async ({ env, aasIdBase64, setError, setSuccess }) => {
  try {
    const blob = new Blob([JSON.stringify(env, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `aas_environment_${aasIdBase64}.json`;

    link.click();
    URL.revokeObjectURL(url);
    setSuccess('Aktion erfolgreich');
  } catch (err) {
    console.error('JSON download failed:', err);
    setError('Failed to download serialized AAS environment.');
  }
};

export default JsonDownloadHandler;
